class AgeGate extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'ageGate';
    this.cookie = Cookies.get(`${this.cookieName}`);
    this.remember = parseInt(this.dataset.remember);

    this.querySelector('button[type="button"]').addEventListener('click', (event) => {
      this.hide();
    });
  }

  connectedCallback() {
    if (this.moved || (this.cookie && this.cookie === 'confirmed')) return;
    this.active = true;
    this.moved = true;
    document.body.appendChild(this);
    this.show();
  }

  show() {
    this.setAttribute('open', '');
    document.body.classList.add('age__gate-open');
    trapFocus(this, this.querySelector('button[type="button"]'));
  }

  hide() {
    if (this.dataset.nocookie === undefined) Cookies.set(`${this.cookieName}`, 'confirmed', { expires: this.remember });
    document.body.classList.remove('age__gate-open');
    this.removeAttribute('open');
    removeTrapFocus();
    this.active = false;
    this.dispatchEvent(new CustomEvent('ageGateClosed', { bubbles: true, detail: { ageGate: this }}));
  }
}

customElements.define('age-gate', AgeGate);
